import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'
import { createIcon } from '../../create-icon'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgColouredHomeFilled = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g filter="url(#filter0_i_15069_275117)">
      <path
        d="M14.7899 6.38451L8.36301 0.137361C8.15179 -0.0457871 7.84821 -0.0457871 7.63699 0.137361L1.21015 6.38451C1.07733 6.49978 1 6.67231 1 6.85433V15.4312C1 15.7452 1.24058 16 1.537 16H5.86595C6.16238 16 6.40296 15.7452 6.40296 15.4312V12.4307C6.40296 12.1167 6.64353 11.8619 6.93996 11.8619H9.06004C9.35647 11.8619 9.59704 12.1167 9.59704 12.4307V15.4312C9.59704 15.7452 9.83762 16 10.134 16H14.463C14.7594 16 15 15.7452 15 15.4312V6.85433C15 6.67231 14.923 6.49978 14.7899 6.38451Z"
        fill="url(#paint0_linear_15069_275117)"
      />
    </g>
    <defs>
      <filter
        id="filter0_i_15069_275117"
        x={1}
        y={-2}
        width={14}
        height={18}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={-2} />
        <feGaussianBlur stdDeviation={2} />
        <feComposite in2="hardAlpha" operator="arithmetic" k2={-1} k3={1} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_15069_275117"
        />
      </filter>
      <linearGradient
        id="paint0_linear_15069_275117"
        x1={12.3265}
        y1={16.5774}
        x2={4.15669}
        y2={4.21452}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00A3FF" />
        <stop offset={1} stopColor="#83EAEC" />
      </linearGradient>
    </defs>
  </svg>
)
const ForwardRef = forwardRef(SvgColouredHomeFilled)
const IconSvgColouredHomeFilled = createIcon(
  ForwardRef,
  'SvgColouredHomeFilled',
)
export default IconSvgColouredHomeFilled
